/* eslint-disable ember/no-controller-access-in-routes, ember/no-runloop, warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';

import { next } from '@ember/runloop';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import moment from 'moment';

export default class DebtorsReportRoute extends Route {
  queryParams = {
    asAtDate: {
      refreshModel: true,
    },
  };

  // Services
  @service
  store;

  @service
  students;

  model(params) {
    let asAtDate = params.asAtDate || '';
    if (!isEmpty(asAtDate) && asAtDate === moment().format('YYYY-MM-DD')) {
      // Don't specify an asAtDate if it's today.  Allows for a simpler query.
      asAtDate = '';
    }
    return hash({
      debtors: this.store.query('finance/debtor', { asAtDate }),
      learners: this.students.all,
    });
  }

  activate() {
    super.activate(...arguments);
    next(this, function () {
      this.controller.reset();
      this.controllerFor('application').set('isWideList', true);
    });
  }

  deactivate() {
    super.deactivate(...arguments);
    this.controller.reset();
    next(this, function () {
      this.controllerFor('application').set('isWideList', false);
    });
  }
}
